/* Vestiganga Mayorista — desplegables del menú ("Nuestros productos").
   Se abren con clic o toque (no dependen del hover); se cierran con Esc o con un clic fuera. */
(function () {
  'use strict';
  if (document.documentElement.dataset.vgMenuInit) return;
  document.documentElement.dataset.vgMenuInit = '1';
  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vg-dd-btn][aria-expanded="true"]'), function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var m = document.getElementById(b.getAttribute('aria-controls')); if (m) m.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vg-dd-btn]');
    if (b) {
      e.preventDefault();
      var m = document.getElementById(b.getAttribute('aria-controls'));
      var open = b.getAttribute('aria-expanded') !== 'true';
      closeAll(b);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (m) m.hidden = !open;
      return;
    }
    if (!(e.target.closest && e.target.closest('[data-vg-dd]'))) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
